/**
 * SITE_CONFIG — Constantes globais do site (URLs, IDs públicos, contato).
 *
 * URLs WhatsApp e Telegram são HARD-FROZEN (CLAUDE.md): só mudar com
 * aprovação humana explícita. Pixel ID idem. Mantemos o JSON sibling
 * (site.json) como single source of truth para que scripts de build
 * (e.g., scripts/generate-schema.mjs) leiam EXATAMENTE os mesmos valores
 * sem duplicação. Se site.json mudar, runtime + build-time ficam em sync.
 *
 * IDs aqui (Pixel `662711039631989`, GA4 `import.meta.env.VITE_GA4_ID`) são
 * PÚBLICOS por design — aparecem no HTML/JS shipped, NÃO são secrets.
 */
import siteJson from "./site.json";

export const SITE_CONFIG = {
  ...siteJson,
  /** Lido de .env.local (VITE_GA4_ID); fallback impede crash em dev sem env. NÃO no JSON (rotatable). */
  ga4Id: import.meta.env.VITE_GA4_ID ?? "G-XXXXXXXXXX",
} as const;
